<ng-content />

@if (this.input().hasContent()) {
  <portal-icon-button class="clear-icon" (onClick)="input().clear()" iconClass="far fa-times" />
}
